import { CallApiOptions } from './api';

export interface FilterParams {
  [additionalFilter: string]: number[] | any;
  color?: number[];
  brand?: number[];
  size?: number[];
  price?: {
    min?: number;
    max?: number;
    sale?: boolean;
  };
}
export const fetchFilterItemsCallOptions = (
  appId: number,
  filterId: string,
  categoryId: number,
  filters: object = {}
): CallApiOptions => ({
  method: 'GET',
  endpoint: `proxies/mobile/${appId}/filters/${filterId}`,
  params: {
    category_id: categoryId,
    filters: JSON.stringify(filters),
  },
});



// WEBPACK FOOTER //
// ./src/services/filters.service.ts